import React, { useState, useRef, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import dropdownStyles from '../assets/css/gapsy-download-dropdown.module.css';
import { useNavigate, useLocation } from 'react-router-dom';
import '../assets/css/gapsybdmupload.css';
import '../assets/css/TemplateForm.css';
import '../assets/css/Operators.css';
import '../assets/css/DEMchecker.css';
import axios from 'axios';
import * as XLSX from 'xlsx';
import '../assets/css/RDMupload.css';
import '../assets/css/style.css';
import '../assets/css/AdminautoBDM.css';
import { FbcDepartmentDropdown } from "../components/Dropdown";
import { Modal, Button, Form, Dropdown, DropdownButton, FaChevronDown } from 'react-bootstrap';
import { BackButton, PreViewButton, previewButtonStyle, UploadButtonStyle, bootstrapbuttonclass, cancelButtonStyle, submitButtonStyle, closeButtonStyle, HeadingStyle, h1, h2, h3, h4, h5, h6, h7, UploadLoadingIcon } from "../components/Propertyfile";
import { upload3001, UploadDemtemplate, Uploadtemplate, PortURL, dropdownlist, ListAlldept, userWisedept } from '../components/ApiProperty';
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { useSession } from '../components/SessionContext';

const GapsyMet = () => {
    const handleDashboard = () => {
        navigate('/gapsyAdashboard');
    };

    const operationalRiskCapitalCharge = 980532;
    const q1CapitalCharge = 55100;
    const q2CapitalCharge = 55100;
    const q3CapitalCharge = 57500;

    const [riskData, setRiskData] = useState([
        {
            area: "Shariah Committee Matters",
            weight: 30,
            observations: 10,
            impact: 4
        },
        {
            area: "Shariah Audit",
            weight: 25,
            observations: 2,
            impact: 3
        },
        {
            area: "Tawarrouq",
            weight: 20,
            observations: 3,
            impact: 2
        },
        {
            area: "Islamic OD",
            weight: 10,
            observations: 1,
            impact: 1
        },
        {
            area: "Ijarah",
            weight: 5,
            observations: 5,
            impact: 2
        },
        {
            area: "Late Payment Charges",
            weight: 10,
            observations: 2,
            impact: 4
        }
    ]);

    const totalIndex = riskData.reduce(
        (sum, row) =>
            sum +
            (row.weight / 100) *
            row.observations *
            row.impact,
        0
    );

    const scoreMatrix = [
        { min: 0, max: 2.5, percentage: 3 },
        { min: 2.5, max: 5, percentage: 6 },
        { min: 5, max: 8, percentage: 9 },
        { min: 8, max: 12, percentage: 12 },
        { min: 12, max: 100, percentage: 15 }
    ];

    const applicablePercentage =
        scoreMatrix.find(item =>
            totalIndex > item.min && totalIndex <= item.max
        )?.percentage || 0;

    const shariahCapitalCharge =
        Math.round(
            operationalRiskCapitalCharge * applicablePercentage / 100
        );

    const q4CapitalCharge = shariahCapitalCharge;

    const finalCapitalCharge =
        Math.round(
            (
                q1CapitalCharge +
                q2CapitalCharge +
                q3CapitalCharge +
                q4CapitalCharge
            ) / 4
        );

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>

            <Header />
            <Navigation />

            {/* Breadcrumb */}
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className={`breadcrumb-item`}>
                                    <a onClick={handleDashboard} className={`text-dark ${styles.breadcrumbLink}`}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                    {/* <span className={styles.separator}>/</span> */}
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-file-code me-2"></i>1.1 File Based Creation
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>

            <main className="flex-grow-1 container-fluid">
                <div>
                    <div className="container-fluid">
                        <div className={`${styles.containerRow} row`}>
                            {/* Left Panel */}
                            <div className="col-lg-4 col-md-12">
                                <div className="card h-100 shadow-sm">
                                    <div className={`tableWrapperLarge ${tableStyles.tableWrapperLarge}`}>
                                        <div className="card-body">

                                            {/* Risk Name */}
                                            <h6 className={`mb-2 ${styles.borderBottom}`}>
                                                Name of Risk : Shariah Non-Compliance Risk
                                            </h6>

                                            {/* Summary */}
                                            <h6>
                                                Summary of Bank's Internal Assessment for Pillar 2 Capital Requirements
                                            </h6>

                                            <p className="text-justify">
                                                <strong>Definition:</strong> Shariah non-compliance risk is the risk that
                                                an Islamic finance transaction is challenged on grounds that it does not
                                                comply with Islamic law.
                                            </p>

                                            <p className="text-justify">
                                                Shariah non-compliance risk can also result in:
                                            </p>

                                            <ul>
                                                <li>
                                                    <strong>Legal Risk</strong> – Failure to comply with contractual
                                                    obligations.
                                                </li>
                                                <li>
                                                    <strong>Compliance Risk</strong> – Risk of non-compliance with laws
                                                    and regulations.
                                                </li>
                                            </ul>


                                            {/* Key Areas */}
                                            <h6>
                                                Key Areas of Risk
                                            </h6>

                                            <p>
                                                The Bank considers the following key areas of risk for Shariah
                                                Non-Compliance:
                                            </p>

                                            {/* Shariah Committee */}
                                            <h6>
                                                Shariah Committee Matters
                                            </h6>

                                            <ul>
                                                <li>Islamic Banking might fail to comply with Shariah Committee guidelines.</li>
                                                <li>Repeated Shariah violations might lead to distrust by the Shariah Committee.</li>
                                                <li>Inappropriate follow-up process of repeated Shariah violations.</li>
                                                <li>Loss of critical documents such as approvals, contracts, and product programs.</li>
                                                <li>Outdated contracts/agreements with Shariah Committee members.</li>
                                            </ul>

                                            {/* Audit */}
                                            <h6>
                                                Shariah Audit
                                            </h6>

                                            <ul>
                                                <li>Inefficient compliance process for Islamic products.</li>
                                                <li>Policies and procedures not updated with latest circulars.</li>
                                                <li>Changes to products not reflected in compliance programs.</li>
                                                <li>Failure to review Shariah violations.</li>
                                                <li>Charging customers non-Shariah compliant fees.</li>
                                                <li>Failure to follow approved Shariah compliance procedures.</li>
                                            </ul>

                                            {/* Late Payment */}
                                            <h6>
                                                Late Payment Charges
                                            </h6>

                                            <ul>
                                                <li>Failure to link late payment charges to the pool account.</li>
                                                <li>Unauthorized access to late payment charge accounts.</li>
                                            </ul>

                                            {/* Tawarrouq */}
                                            <h6>
                                                Tawarrouq
                                            </h6>

                                            <p>Key risks related to tawarrouq finance are as follows:</p>
                                            <ul>
                                                <li>Using non-sharia approved documents.</li>
                                                <li>Selling non-sharia compliant commodity.</li>
                                                <li>Missing major information in the offer and acceptance with the customer.</li>
                                                <li>Adjusting the rate without executing commodity sale transaction in the rollover/Floating deals.</li>
                                                <li>Executing commodity sale transaction in a back value date (for the rollover/Floating deals) without getting Islamic Banking's approval.</li>
                                            </ul>
                                            <h6>Islamic OD:</h6>
                                            <p>Key risks related to Islamic OD are as follows:</p>
                                            <ul>
                                                <li>Investing Wakalah pool’s funds in non-Sharia compliant investment.</li>
                                                <li>Income from Wakalah pool is different from Tawarrouq profit margin for the Islamic OD product.</li>
                                            </ul>
                                            <h6 className="fw-bold mt-3">Ijarah (Lease) of Real estate/Equipment</h6>
                                            <p>Key risks related to Ijara are as follows:</p>
                                            <ul>
                                                <li>ANB lease Non-owned Equipment /Real Estate to customer.</li>
                                            </ul>


                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Right Panel */}
                            <div className="col-lg-8 col-md-12">
                                <div className="card h-100 shadow-sm">
                                    <div className={`tableWrapperLarge ${tableStyles.tableWrapperLarge}`}>
                                        <div className="card-body">

                                            <h6 className={`${styles.borderBottom}`}>
                                                Risk Measurement Methodology
                                            </h6>

                                            <p className="mb-3">
                                                Keeping in view the above Key Risk Factors, the bank calculates
                                                the <strong>Shariah Non-Compliance Risk Index</strong> as per the
                                                following matrix.
                                            </p>

                                            <div className="d-flex justify-content-between mb-3">
                                                <h6 className="fw-bold">Period : Q4 2025</h6>
                                            </div>

                                            <div className='table-on-homepage-only'>
                                                <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`} style={{ tableLayout: "fixed" }}>

                                                    <thead className="thead-light">
                                                        <tr>
                                                            <th style={{ width: "30%" }}>Key Areas</th>
                                                            <th style={{ width: "12%" }}>Weight (%)</th>
                                                            <th title="No. of Observations / Issues / Non-Compliance / Delays / Self Assessment (B)" style={{ width: "23%" }}>
                                                                No. of Observations
                                                            </th>
                                                            <th style={{ width: "20%" }}>
                                                                Impact (1 - 10) (C)
                                                            </th>
                                                            <th style={{ width: "15%" }}>Index</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {
                                                            riskData.map((row, index) => {

                                                                const indexValue =
                                                                    (row.weight / 100) *
                                                                    row.observations *
                                                                    row.impact;

                                                                return (
                                                                    <tr key={index}>

                                                                        <td className="text-start">{row.area}</td>

                                                                        <td>{row.weight}%</td>

                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control text-center"
                                                                                value={row.observations}
                                                                                onChange={(e) => {
                                                                                    const data = [...riskData];
                                                                                    data[index].observations = Number(e.target.value);
                                                                                    setRiskData(data);
                                                                                }}
                                                                            />
                                                                        </td>

                                                                        <td>
                                                                            <input
                                                                                type="number"
                                                                                className="form-control text-center"
                                                                                min="1"
                                                                                max="10"
                                                                                value={row.impact}
                                                                                onChange={(e) => {
                                                                                    const data = [...riskData];
                                                                                    data[index].impact = Number(e.target.value);
                                                                                    setRiskData(data);
                                                                                }}
                                                                            />
                                                                        </td>

                                                                        <td className="fw-bold">
                                                                            {indexValue.toFixed(2)}
                                                                        </td>

                                                                    </tr>
                                                                )
                                                            })
                                                        }
                                                    </tbody>

                                                    <tfoot className="table-light fw-bold">
                                                        <tr>
                                                            <td className="text-end">Total</td>
                                                            <td>100%</td>
                                                            <td></td>
                                                            <td></td>
                                                            <td>{totalIndex.toFixed(2)}</td>
                                                        </tr>
                                                    </tfoot>

                                                </table>

                                                {/* ================= Reference ================= */}

                                                <hr className="my-4" />

                                                <h6>
                                                    Score Grade Matrix
                                                </h6>
                                                <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                    <thead className="thead-light">
                                                        <tr>
                                                            <th>Score Grade</th>
                                                            <th>Min</th>
                                                            <th>Max</th>
                                                            <th title="Operational Risk Pillar I Capital Charge (%)">Operational Risk</th>
                                                            <th>Applicable Percentage (%)</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {
                                                            scoreMatrix.map((row, index) => {

                                                                const isApplicable =
                                                                    totalIndex >= row.min &&
                                                                    totalIndex <= row.max;

                                                                return (
                                                                    <tr key={index}>
                                                                        <td>
                                                                            {index === 0
                                                                                ? `${row.min} - ${row.max}`
                                                                                : `>${row.min} - ${row.max}`}
                                                                        </td>

                                                                        <td>{row.min}</td>

                                                                        <td>{row.max}</td>

                                                                        <td>{row.percentage}%</td>

                                                                        <td className="fw-bold">
                                                                            {isApplicable
                                                                                ? `${row.percentage.toFixed(2)}%`
                                                                                : "0.00%"}
                                                                        </td>

                                                                    </tr>
                                                                )

                                                            })
                                                        }
                                                    </tbody>
                                                </table>

                                              
                                                <h6>
                                                    Capital Charge Summary
                                                </h6>

                                                <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                    <tbody>

                                                        <tr>
                                                            <th style={{ width: "70%" }} className="text-start">
                                                                Operational Risk Pillar I Capital Charge (SAR 000's)
                                                            </th>

                                                            <td className="text-end">
                                                                {operationalRiskCapitalCharge.toLocaleString()}
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <th className="text-start">
                                                                Applicable % Capital Charge for Shariah Risk
                                                            </th>

                                                            <td className="text-end">
                                                                {applicablePercentage.toFixed(2)}%
                                                            </td>
                                                        </tr>

                                                        <tr className="table-light fw-bold">
                                                            <th className="text-start">
                                                                Capital Charge for Shariah Risk
                                                            </th>

                                                            <td className="text-end">
                                                                {shariahCapitalCharge.toLocaleString()}
                                                            </td>
                                                        </tr>

                                                    </tbody>
                                                </table>

                                                <hr className="my-4" />

                                                <h6>
                                                    Quarterly Capital Charge
                                                </h6>

                                                <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                    <thead className="table-light">
                                                        <tr>
                                                            <th>Q1-2025</th>
                                                            <th>Q2-2025</th>
                                                            <th>Q3-2025</th>
                                                            <th>Q4-2025</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        <tr>
                                                            <td>{q1CapitalCharge.toLocaleString()}</td>
                                                            <td>{q2CapitalCharge.toLocaleString()}</td>
                                                            <td>{q3CapitalCharge.toLocaleString()}</td>
                                                            <td>{q4CapitalCharge.toLocaleString()}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                                <table className={`table table-bordered table-hover ${tableStyles.customScrollTable}`}>
                                                    <tbody>
                                                        <tr className="table-success fw-bold">
                                                            <th style={{ width: "75%" }}>
                                                                Final Capital Charge for 31-Dec-2025 (Average of 4 Quarters)
                                                            </th>

                                                            <td className="text-end">
                                                                {finalCapitalCharge.toLocaleString()}
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <div></div>

        </div>
    );
};

export default GapsyMet;